import React, { Component } from 'react'
import Exclass from '../../Exos/ExClass/ExClass'
import NewMyCars from '../../Exos/NewMyCars/NewMyCars'
import Slide from '../../Slide/Slide'
import Maman from '../../Exos/Maman/Maman'
import Result from '../../Exos/IfClass/Game'
import Form from '../../Exos/FormImage/FormImage'
import LifeCycle from '../../Exos/LifeCycleCD_Update/LifeCycle'
import ClassState from '../../Exos/StateInClass/ClassState'
import FonctionState from '../../Exos/FonctionState/FonctionState'
import Todo from '../../Exos/Todo/Todo'
// import FonctionCount from '../../Exos/FonctionCount/FonctionCount'
import Container from '../../Exos/showHide/ContainerUseEffectCWU'
// import ClassCount from '../../Exos/ClassCount/ClassCount'
// import ImportUnity from '../../GalleryVirtuelleLallemand/Build/ImportUnity'
import Profile from '../../Exos/8-useContext/Profile'
import {UserContext, ColorContext} from '../../Exos/8-useContext/MyContext'
import Count from '../../Exos/9-UserReducerDoubleCount/Count'
import Multicarousel from '../../MultiCarousel/MultiCarousel'


class GalerieVirtuelle extends Component {

    state = {
        user : {
            name : 'lisa',
            age : 8
        },
        display: true
    }

    effacerOuAfficher = () =>
    {
        if(this.state.display){   // j'aurais pu faire juste !this.state.display ; c'est a dire: si il n'est pas égale à lui même alors modifie ce state
        this.setState({
            display : false
        })
        } else{
            this.setState({
                display: true
            })
        }
    }

    render(){

        const showComponent = this.state.display === true ? (<LifeCycle name="Toto2"/>) : (<div></div>) ;

        // var ordreAppartition = 2 // cntext.odreSectext == 2

        // const showComponentSecText = ordreAppartition && (<LifeCycle style={{order : ordreAppartition}}/>)  ;






    return (
            <div>

                

                <div className='text-center'>
                    <Count />
                </div>
                
                <div>
                   <UserContext.Provider value={this.state.user}> 
                        <ColorContext.Provider value={'red'}>
                            <Profile />
                        </ColorContext.Provider>
                   </UserContext.Provider>
                </div>

                <div>
                <Multicarousel  />
                </div>

                <div>
                    
                    <Container />
                </div>



                <div>
                    {/* <FonctionCount /> */}
                    
                </div>
            

                <div className="container">
                    <Todo />
                </div>

                <div className='text-center h1'>
                    <FonctionState />
                </div>

                <hr />

                <div className='text-center h1'>
                    <ClassState />
                </div>



                <div className='text-center'>

                    {showComponent}
                    
                    <button onClick={this.effacerOuAfficher} className='btn btn-info'>Cliquez ici </button>
                </div>

                <div className="text-center">
                    <Form />
                </div>

                <div>
                    <Result />
                </div>

                <div>
                    <Maman />
                </div>


                <div className="text-center h1 bg-secondary text-white p-5">
                    Galerie Virtuelle
                </div>

                <div className="container text-center">
                <Exclass />
                </div>

                <div>
                    <NewMyCars />
                </div>

                <div>
                    <Slide />
                </div>

                
            

            </div>

        )

    }
    
}

export default GalerieVirtuelle